import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, id, ...params }) =>
  client
    .fsps(fspId)
    .ddaAuditLogs.query(formatQueryParams({ ddaId: id, ...params }));
